import { isAvailable, requestPermission, sendNotification } from '../../../../../helper/push-notification';
import Analytics from './Analytics';

class PushNotification {
    listener = false;
    constructor() {}

    isAvailable() {
        //check if notification is supported
        return isAvailable();
    }

    handlePushNotification() {
        if (Notification.permission === 'granted') {
            Analytics.send('notification_action', 'push_notification_granted');
            return true;
        }
        if (Notification.permission === 'denied') {
            Analytics.send('notification_action', 'push_notification_denied');
            return false;
        }
        requestPermission().then(function () {
            if (Notification.permission === 'granted') {
                if (Notification.permission === 'granted') {
                    Analytics.send('notification_action', 'push_notification_granted');
                    return true;
                }

                if (Notification.permission === 'denied') {
                    Analytics.send('notification_action', 'push_notification_denied');
                    return false;
                }
            }
        });
    }
    sendNotification(text) {
        sendNotification(text);
    }
}

export default new PushNotification();
